import { lugaresTuristicos } from '@/assets/data/lugares.js';
export function getAllPlaces() {
    return [...lugaresTuristicos];
}
export function getPlaceById(id) {
    return lugaresTuristicos.find(p => String(p.id) === String(id)) || null;
}
export function searchPlaces({ query = '', categoria = '', ciudad = '', region = '', tipo = '' } = {}) {
    const q = query.trim().toLowerCase();
    return lugaresTuristicos.filter(place => {
        const inQuery = !q || [place.nombre, place.descripcion, place.region]
            .filter(Boolean)
            .some(text => String(text).toLowerCase().includes(q));
        const inRegion = !region || String(place.region).toLowerCase() === String(region).toLowerCase();
        const inCategoria = !categoria;
        const inCiudad = !ciudad;
        const inTipo = !tipo;
        return inQuery && inRegion && inCategoria && inCiudad && inTipo;
    });
}
